import { render } from "./indicator-add-model.vue?vue&type=template&id=8e1a1f70"
import script from "./indicator-add-model.vue?vue&type=script&lang=js"
export * from "./indicator-add-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__